import {ParseResult} from './markdown';

const wrappingTags = [
	{
		tag: 'unorderedListItem',
		wrap: 'ul',
		nextTag: 'li',
	},
	{
		tag: 'orderedListItem',
		wrap: 'ol',
		nextTag: 'li',
	},
	{
		tag: 'blockquoteChild',
		wrap: 'blockquote',
		nextTag: 'p',
	},
];

export function wrapTags(tree: ParseResult[]) {
	const newResult: ParseResult[] = [];
	let lastWrappingTag: string | null = null;
	let wrappingList: ParseResult[] = [];

	function addToResult(lastWrappingTag: string) {
		// Находим обертку для отслеживаемого тега
		const wrapping = wrappingTags.find((tag) => tag.tag === lastWrappingTag);
		if (wrapping) {
			newResult.push({
				tag: wrapping.wrap,
				children: wrappingList.map((item) => ({...item, tag: wrapping.nextTag})),
			});
		}
	}

	for (let item of tree) {
		// Мы отслеживаем элементы, которые должны обернуть. Если новый элемент другого типа, значит отслеживанию конец.
		// Оборачиваем то, что отслеживали и добавляем в результат. Перестаем отслеживать
		if (lastWrappingTag && lastWrappingTag !== item.tag) {
			addToResult(lastWrappingTag);
			wrappingList = [];
			lastWrappingTag = null;
		}

		// Продолжаем отслеживать
		if (lastWrappingTag === item.tag) {
			wrappingList.push(item);
		} else {
			// Смотрим, не находится ли наш тег в списке отслеживания
			const wrapping = wrappingTags.find((tag) => tag.tag === item.tag);
			// Находится, начинаем отслеживать
			if (wrapping) {
				lastWrappingTag = item.tag;
				wrappingList = [item];
				// Записываем элемент в результат
			} else {
				newResult.push(item);
			}
		}
	}
	if (lastWrappingTag) {
		addToResult(lastWrappingTag);
	}
	return newResult;
}
